import React from "react";
import Index from "./index";
import EnquiriesTable from "./EnquiriesTable";

const Enquiries = () => {
    const { enquiries, loading, history, search, setSearch, onDelete } = Index();

    return (
        <EnquiriesTable
            heading="Enquiries List"
            enquiries={enquiries}
            loading={loading}
            history={history}
            search={search}
            setSearch={setSearch}
            onDelete={onDelete}
        />
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname && prevProps.colorMode === nextProps.colorMode;
};
export default React.memo(Enquiries, comparisonFn);
